const headerLogo = document.querySelector(".header__logo img");
const logoSrc = headerLogo.getAttribute("src");
const logoData = headerLogo.getAttribute("data-alt");
const bodyEl = document.querySelector("body");
const parallaxEl = document.getElementsByClassName("parallax");
const counters = document.querySelectorAll(".numbers__item span");
if (counters) {
  counters.forEach(counter => {
    valueWidth = counter.offsetWidth;
    counter.style.width = `${valueWidth}px`;
    counter.dataset.value = counter.innerText;
    counter.innerText = "0";
  });
}
let lastScrollTop = 0;
function scrollDown() {
  const win_width = window.innerWidth;
  const top = window.scrollY;

  //Header animation
  const headerEl = document.getElementById("header");
  //if (win_width > 900) {
  if (top > 80) {
    headerEl.classList.add("scroll");
    headerLogo.setAttribute("src", logoData);
  } else {
    headerEl.classList.remove("scroll");
    headerLogo.setAttribute("src", logoSrc);
  }
  //}

  if (top > lastScrollTop && top > 600) {
    // Scrolling Down
    headerEl.classList.remove("scroll-up");
    headerEl.classList.add("scroll-down");
  } else if (top < lastScrollTop) {
    // Scrolling Up
    headerEl.classList.remove("scroll-down");
    headerEl.classList.add("scroll-up");
  }
  if (top <= 10) {
    headerEl.classList.remove("scroll-up", "scroll-down");
  }
  lastScrollTop = top;
}
setTimeout(function () {
  document.querySelector("body").classList.add("loaded");
}, 800);
scrollDown();
window.addEventListener("scroll", function (e) {
  scrollDown();
});